import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Usage`}</h2>
    <p>{`Textfields allow user input. The border should light up simply and clearly indicating which field the user is currently editing.`}</p>
    <div className="divi" />
    <h3><strong parentName="h3">{`Basic`}</strong></h3>
    <p>{`Here’s the default usage of Textfield with placeholder and label attribute set.`}</p>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-basic.png",
      "alt": "android basic"
    }}></img>
    <h4>{`Xml Code`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<com.telkom.legion.component.textfield.LgnSingleField
    android:id="@+id/etEmail"
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Email"
    app:placeholderText="Email atau Username" />
`}</code></pre>
    <h4>{`Add TextChange Listener`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`with(binding) {
    etEmail.doOnTextChanged { text, start, before, count ->
        //Do your action here
    }
}
`}</code></pre>
    <br />
    <br />
    <h3><strong parentName="h3">{`Icon`}</strong></h3>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-icon.png",
      "alt": "android textfield icon"
    }}></img>
    <h4>{`Xml Code`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<com.telkom.legion.component.textfield.LgnSingleField
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Sample End Icon"
    app:endIconDrawable="@drawable/ic_clock"
    app:isOptional="true"
    app:placeholderText="Email atau Username" />
`}</code></pre>
    <br />
    <br />
    <h3><strong parentName="h3">{`Prefix & Suffix`}</strong></h3>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-prefix.png",
      "alt": "prefix and suffix textfield"
    }}></img>
    <h4>{`Xml Code`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<com.telkom.legion.component.textfield.LgnSingleField
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Biaya"
    app:helperText="Masukan Email dan Username anda!"
    app:placeholderText="Email atau Username"
    app:prefixText="Rp" />
`}</code></pre>
    <br />
    <br />
    <h3><strong parentName="h3">{`Disabled`}</strong></h3>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-disabled.png",
      "alt": "disabled textfield"
    }}></img>
    <h4>{`Xml Code`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<com.telkom.legion.component.textfield.LgnSingleField
    android:id="@+id/etEmail"
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Email"
    android:enable="false"
    app:placeholderText="Email atau Username" />
`}</code></pre>
    <br />
    <br />
    <h3><strong parentName="h3">{`Error`}</strong></h3>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-error.png",
      "alt": "android textfield error"
    }}></img>
    <h4>{`Xml Code`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<com.telkom.legion.component.textfield.LgnSingleField
    android:id="@+id/etEmail"
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Email"
    app:placeholderText="Email atau Username" />
`}</code></pre>
    <h4>{`Kotlin Code`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "title=\"SampleFragment.kt\"",
        "title": "\"SampleFragment.kt\""
      }}>{`...
with(binding) {
    etEmail.error = "Email sudah digunakan!"
}
...
`}</code></pre>
    <br />
    <br />
    <h3><strong parentName="h3">{`Success`}</strong></h3>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-success.png",
      "alt": "textfield success"
    }}></img>
    <h4>{`Xml Code`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<com.telkom.legion.component.textfield.LgnSingleField
    android:id="@+id/etEmail"
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Email"
    app:placeholderText="Email atau Username" />
`}</code></pre>
    <h4>{`Kotlin Code`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "title=\"SampleFragment.kt\"",
        "title": "\"SampleFragment.kt\""
      }}>{`...
with(binding) {
    etEmail.succcess = "Email bisa digunakan!"
}
...
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`Password Field`}</strong></h3>
    <p>{`Here’s the password usage of Textfield with placeholder and label attribute set.`}</p>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-2.png",
      "alt": "password field"
    }}></img>
    <br />
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-passwords.gif",
      "alt": "password field"
    }}></img>
    <h4>{`Static in xml`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<com.telkom.legion.component.textfield.LgnPasswordField
    android:id="@+id/etPassword"
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Kata Sandi"
    app:placeholderText="Email atau Username" />
`}</code></pre>
    <h4>{`Dynamic using Kotlin`}{`*`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "title=\"SampleFragment.kt\"",
        "title": "\"SampleFragment.kt\""
      }}>{`...
with(binding) {
    containerBase.addView( //ViewGroup for Dynamic Layout
        LgnPasswordField(requiredContext()).apply {
            //Your View's customization here
        },
        LinearLayout.LayoutParams( //For example we use viewgroup LinearLayout
            LinearLayout.LayoutParams.MATCH_PARENT,
            LinearLayout.LayoutParams.WRAP_CONTENT
        )
    )
}
...
`}</code></pre>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p><strong parentName="p">{`*`}{`) :`}</strong>{` Dynamic using Kotlin mean if you using Dynamic Layout or Declarative UI using kotlin`}</p>
    </InlineNotification>
    <div className="divi" />
    <h3><strong parentName="h3">{`Date Field`}</strong></h3>
    <p>{`Here’s the date picker usage of Textfield with placeholder and label attribute set.`}</p>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-3.png",
      "alt": "date field"
    }}></img>
    <br />
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-datepicker.gif",
      "alt": "date field"
    }}></img>
    <h4>{`Static in xml`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<com.telkom.legion.component.textfield.LgnCalendarField
    android:id="@+id/etCalendar"
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Tanggal Lahir"
    app:dateFormat="FULL_DATE"
    app:helperText="Pilih tanggal lahir anda!"
    app:placeholderText="Tanggal Lahir" />
`}</code></pre>
    <h4>{`Dynamic using Kotlin`}{`*`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "title=\"SampleFragment.kt\"",
        "title": "\"SampleFragment.kt\""
      }}>{`...
with(binding) {
    containerBase.addView( //ViewGroup for Dynamic Layout
        LgnCalendarField(requiredContext()).apply {
            //Your View's customization here
        },
        LinearLayout.LayoutParams( //For example we use viewgroup LinearLayout
            LinearLayout.LayoutParams.MATCH_PARENT,
            LinearLayout.LayoutParams.WRAP_CONTENT
        )
    )
}
...
`}</code></pre>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p><strong parentName="p">{`*`}{`) :`}</strong>{` Dynamic using Kotlin mean if you using Dynamic Layout or Declarative UI using kotlin`}</p>
    </InlineNotification>
    <div className="divi" />
    <h3><strong parentName="h3">{`Time Field`}</strong></h3>
    <p>{`Here’s the time picker usage of Textfield with placeholder and label attribute set.`}</p>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-4.png",
      "alt": "time field"
    }}></img>
    <br />
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-timefield.gif",
      "alt": "time field"
    }}></img>
    <h4>{`Static in xml`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<com.telkom.legion.component.textfield.LgnTimeField
    android:id="@+id/etTime"
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Waktu"
    app:placeholderText="Waktu Budidaya" />
`}</code></pre>
    <h4>{`Dynamic using Kotlin`}{`*`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "title=\"SampleFragment.kt\"",
        "title": "\"SampleFragment.kt\""
      }}>{`...
with(binding) {
    containerBase.addView( //ViewGroup for Dynamic Layout
        LgnTimeField(requiredContext()).apply {
            //Your View's customization here
        },
        LinearLayout.LayoutParams( //For example we use viewgroup LinearLayout
            LinearLayout.LayoutParams.MATCH_PARENT,
            LinearLayout.LayoutParams.WRAP_CONTENT
        )
    )
}
...
`}</code></pre>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p><strong parentName="p">{`*`}{`) :`}</strong>{` Dynamic using Kotlin mean if you using Dynamic Layout or Declarative UI using kotlin`}</p>
    </InlineNotification>
    <div className="divi" />
    <h3><strong parentName="h3">{`Dropdown Field`}</strong></h3>
    <p>{`Here’s the dropdown usage of Textfield with placeholder and label attribute set.`}</p>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-5.png",
      "alt": "dropdown field"
    }}></img>
    <br />
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-dropdown.gif",
      "alt": "dropdown field"
    }}></img>
    <h4>{`Static in xml`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<com.telkom.legion.component.textfield.LgnDropdownField
    android:id="@+id/etDropDown"
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Kategori"
    app:helperText="Kategori Panen!"
    app:isOptional="true"
    app:placeholderText="Masukan Kategori Panen" />
`}</code></pre>
    <h4>{`Dynamic using Kotlin`}{`*`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "title=\"SampleFragment.kt\"",
        "title": "\"SampleFragment.kt\""
      }}>{`...
with(binding) {
    containerBase.addView( //ViewGroup for Dynamic Layout
        LgnDropdownField(requiredContext()).apply {
            //Your View's customization here
        },
        LinearLayout.LayoutParams( //For example we use viewgroup LinearLayout
            LinearLayout.LayoutParams.MATCH_PARENT,
            LinearLayout.LayoutParams.WRAP_CONTENT
        )
    )
}
...
`}</code></pre>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p><strong parentName="p">{`*`}{`) :`}</strong>{` Dynamic using Kotlin mean if you using Dynamic Layout or Declarative UI using kotlin`}</p>
    </InlineNotification>
    <div className="divi" />
    <h3><strong parentName="h3">{`Unit Field`}</strong></h3>
    <p>{`Here’s the set of number field and dropdown field.`}</p>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-6.png",
      "alt": "unit field"
    }}></img>
    <br />
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/textfield/android-unit.gif",
      "alt": "unit field"
    }}></img>
    <h4>{`Static in xml`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<com.telkom.legion.component.textfield.LgnSingleUnitField
    android:id="@+id/etUnit"
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Luas Area"
    android:inputType="number"
    app:placeholderText="Masukkan luas area" />
`}</code></pre>
    <h4>{`Dynamic using Kotlin`}{`*`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "title=\"SampleFragment.kt\"",
        "title": "\"SampleFragment.kt\""
      }}>{`...
with(binding) {
    containerBase.addView( //ViewGroup for Dynamic Layout
        LgnSingleUnitField(requiredContext()).apply {
            //Your View's customization here
        },
        LinearLayout.LayoutParams( //For example we use viewgroup LinearLayout
            LinearLayout.LayoutParams.MATCH_PARENT,
            LinearLayout.LayoutParams.WRAP_CONTENT
        )
    )
}
...
`}</code></pre>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p><strong parentName="p">{`*`}{`) :`}</strong>{` Dynamic using Kotlin mean if you using Dynamic Layout or Declarative UI using kotlin`}</p>
    </InlineNotification>
    <div className="divi" />
    <h2>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Component Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Id`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`TextView`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`tvHint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To display label on text area`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`TextInputLayout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`etBase`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To display text field on text area`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`TextView`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`tvHelper`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To display helper text on text area`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`TextView`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`tvError`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To display error text on text area`}</td>
        </tr>
      </tbody>
    </table>
    <br />
    <h2>{`Attributes`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Attribute Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Xml Attrs`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Related method(s)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`android:text`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set Text value directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`android:hint`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set Hint or Label value directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Enable Status`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`android:enabled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`isEnable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set enable or disable text area directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Required Status`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:isRequired`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`isRequired`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set required status on text area directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional Status`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:isOptional`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`isOptional`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set optional status on text area directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Placeholder text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:placeholderText`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`placeHolder`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set placeholder text directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Helper text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:helperText`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`helper`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set helper text directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Suffix Text ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:suffixText`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`suffixText`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set suffix text on text field directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Prefix Text ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:prefixText`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`prefixText`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set prefix text on text field directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Input Type ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`android:inputType`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`inputType`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set input type on text field directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Start Icon Drawable ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:startIconDrawable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`startIconDrawable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set icon on front text field directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`End Icon Drawable ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:endIconDrawable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`endIconDrawable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set icon on behind text field directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Prefix End Icon Drawable ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:prefixEndIconDrawable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`prefixEndIconDrawable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set icon on behind text prefix on text field directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Prefix Start Icon Drawable ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:prefixStartIconDrawable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`prefixStartIconDrawable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set icon on front text prefix on text field directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Suffix End Icon Drawable ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:suffixEndIconDrawable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`suffixEndIconDrawable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set icon on behind text suffix on text field directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Suffix Start Icon Drawable ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:suffixStartIconDrawable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`suffixStartIconDrawable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set icon on front text suffix on text field directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Max Lines ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`android:maxLines`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`maxLines`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set maximum lines on text field directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Max Length ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`android:maxLength`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`maxLength`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set max length on text field directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ellipsize Placement ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`android:ellipsize`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ellipsize`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set where Ellipsize on text field directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Locked Field ¹`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`isLocked`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set locked field on `}<em parentName="td">{`LgnSingleField`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Date Format ²`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:dateFormat`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`dateFormat`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set date format text directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Time Format ³`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:timeFormat`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`timeFormat`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set time format text directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Override Dropdown Behaviour ⁴ ⁵`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:overrideDropdown`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`overrideDropdown`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To override default behaviour of dropdown`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Get Edit Text Instance`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`editText`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To get edit text instance from component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Add Values ⁴ ⁵`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`addAll(List<String>)`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set list of string to dropdown on component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Add Click Listener ⁴ ⁵`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`setOnClickListener`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set click listener on dropdown if you want override default behaviour`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Add Dropdown Listener ⁴`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`setListener`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set listener on dropdown when value changed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Add Unit Listener ⁵`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`setOnUnitListener`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set listener on dropdown on unit field when value changed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Get Selected Unit Value ⁵`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unit`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To get selected unit on unit field`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Get Edit Text on Dropdown Field Instance ⁵`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`dropDown`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To get edittext on dropdown field instance on unit field`}</td>
        </tr>
      </tbody>
    </table>
    <InlineNotification kind="info" mdxType="InlineNotification">
      <p>{`¹) : Attribute only available on LgnSingleField Component`}</p>
      <br />
      <p>{`²) : Attribute only available on LgnCalendarField Component`}</p>
      <br />
      <br />
      <p>{`³) : Attribute only available on LgnTimeField Component`}</p>
      <br />
      <br />
      <p>{`⁴) : Attribute only available on LgnDropdownField Component`}</p>
      <br />
      <br />
      <p>{`⁵) : Attribute only available on LgnSingleUnitField Component`}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      